import styled from 'styled-components';
import { BasicInput } from 'common/common.styles';

export const Input = styled(BasicInput)`
  width: 200px;
`;
